import type { MovementRules } from "./combat-rules.js";

export const MOVEMENT_RULES: MovementRules = Object.freeze({
  energyPerSecond: 13,
  boostEnergyPerSecond: 32,
  boostSpeedFactor: 1.8,
  forwardBase: 0.64,
  forwardGain: 0.36,
  reverseFactor: 0.6,
});
